import { render, staticRenderFns } from "./ShoppingProgress.vue?vue&type=template&id=50548442&"
import script from "./ShoppingProgress.vue?vue&type=script&lang=js&"
export * from "./ShoppingProgress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports